import { Typography, Input, Button, InputLabel, Snackbar, Alert, Box, ButtonGroup } from "@mui/material"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { useEffect, useState } from "react"
import { bulkUploadAsync, bulkUploadReset, bulkUploadSamplesAsync, fetchHistory, selectBulkSamples, selectBulkSamplesStatus, selectBulkUploadrData, selectBulkUploadrHistory } from "./BulkUploadrSlice"
import { Check } from "@mui/icons-material"
import FileUpload from "../utils/fileupload/FileUpload"
import { DataGrid, GridCallbackDetails, GridRowParams, MuiEvent } from '@mui/x-data-grid'
import { epochToDate } from "../utils/DateUtil"
import { useNavigate } from "react-router-dom"
import { grey } from "@mui/material/colors"
import DropDownMenu, { DropDownMenuItem } from "../utils/DropDownMenu"

const BulkUploadr = () => {
  const [files, setFiles] = useState<File[]>([]);
  const [template, setTemplate] = useState('SIMPLE')
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const bulkUploadrData = useAppSelector(selectBulkUploadrData)
  const bulkUploadHistory = useAppSelector(selectBulkUploadrHistory)
  const bulkSamples = useAppSelector(selectBulkSamples)
  const bulkSamplesStatus = useAppSelector(selectBulkSamplesStatus)
  const historyColumns = [
    { flex: 1, field: 'size', headerName: 'Records', type: 'number' },
    { flex: 1, field: 'submitDate', headerName: 'Submitted', valueGetter: (params: any) => epochToDate(params.row.submitDate) },
    { flex: 1, field: 'completeDate', headerName: 'Completed', valueGetter: (params: any) => params.row.completeDate ? epochToDate(params.row.completeDate) : '~' },
    { flex: 1, field: 'success', headerName: 'Analysis Status', valueGetter: (params: any) => params.row.completeDate ? 'Complete' : 'In progress' },
  ];

  useEffect(() => {
    dispatch(bulkUploadSamplesAsync())
    dispatch(fetchHistory({}))
  }, [dispatch])

  const submitForProcessing = () => {
    const form = new FormData()
    form.append('file', files[0])
    dispatch(bulkUploadAsync({ form, template }))
    setTimeout(() => dispatch(fetchHistory({})), 1000)
  }
  const handleCloseUploaded = () => {
    dispatch(bulkUploadReset(''))
    setFiles([])
  }

  return <>
    <Box sx={{ marginBottom: 2 }}>
      <Typography variant="h3">Upload bulk addresses</Typography>
      {/* <Typography variant="body2" sx={{ color: grey[500] }}>The file should contain 2 columns only, first column should contain slno.and second column should contain the address in USPS format.</Typography> */}
      <Typography variant="body2" sx={{ color: grey[500] }}>For reference/examples, download one of the buttons below.</Typography>
      <ButtonGroup disabled={bulkSamplesStatus === 'loading'}>
        {bulkSamples && Object.keys(bulkSamples).map((key) => {
          return <Button key={key} href={bulkSamples[key]}>{key}</Button>
        })}
      </ButtonGroup>
    </Box>
    <Snackbar open={bulkUploadrData?.id?.length > 0} autoHideDuration={10000} onClose={handleCloseUploaded}>
      <Alert icon={<Check fontSize="inherit" />} onClose={handleCloseUploaded} sx={{ width: '100%' }}>
        Upload success, reference id: {bulkUploadrData?.id}
      </Alert>
    </Snackbar>

    <FileUpload maxFiles={1} maxSize={10 * 1048576} value={files} onChange={setFiles}
      accept={{ 'application/vnd.ms-excel': ['.xlsx', '.xls'], 'text/csv': ['.csv'] }}
      sx={{ marginBottom: 2 }} buttonText="Select File" />

    <DropDownMenu title="Excel Template" default={{ id: 'SIMPLE', label: 'Simple' }}
      items={[{ id: 'SIMPLE', label: 'Simple' },
      { id: 'APPFOLIO', label: 'Appfolio' },
      { id: 'PROPERTYWARE', label: 'Propertyware' }]}
      onUpdate={(oldItem: DropDownMenuItem, newItem: DropDownMenuItem) => {
        setTemplate(newItem.id)
      }} />

    {<Button variant="contained" disabled={files.length === 0} onClick={submitForProcessing}>Submit for processing</Button>}

    <hr />

    {bulkUploadHistory && bulkUploadHistory.length && <DataGrid sx={{
      // disable cell selection style
      '.MuiDataGrid-cell:focus': {
        outline: 'none'
      },
      // pointer cursor on ALL rows
      '& .MuiDataGrid-row:hover': {
        cursor: 'pointer'
      }
    }} rows={bulkUploadHistory} columns={historyColumns} onRowClick={(params: GridRowParams, event: MuiEvent<React.MouseEvent>, details: GridCallbackDetails) => {
      navigate(`/bulk/history/${params.row.id}`)
    }} />}
  </>
}

export default BulkUploadr